<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    :scrollable="false"
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn v-if="!mandatory" text @click="close(false)">{{ $t("close") }}</v-btn></v-col
          >

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$appMode == 0 && $store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ title }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right"></v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
        <iframe
          id="iframeId"
          x-scrolling="no"
          :class="{ 'iframe-mobile': $vuetify.breakpoint.smAndDown }"
          :src="url"
        ></iframe>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    title: "",
    url: "",
    mandatory: false,

    iframeLoaded: 0,
  }),

  mounted() {},

  methods: {
    open(title, url, mandatory) {
      this.title = this.$t("form.title");
      if (title != null && title != "") this.title = title;

      this.url = url;

      this.mandatory = mandatory!=null&&mandatory;

      let that = this;
      setTimeout(function() {
        var iframe = document.getElementById("iframeId");
        if (iframe != null) {
          iframe.onload = function() {
            that.iframeLoaded++;
            if (that.iframeLoaded > 1) {
              that.close(true);
            }
          };
        }
      }, 500);

      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close(result) {
      this.dialog = false;
      this.resolve(result);
    },
  },
};
</script>

<style lang="scss" scoped>
#iframeId {
  //set the height to 100% of the viewport less the height of the header
  height: calc(90vh - 12px - #{$header-height});
  width: 100%;

  //remove border, padding, margin
  border: none;
  padding: 0;
  margin: 0;
}

.iframe-mobile {
  height: calc(100vh - 12px - #{$header-height}) !important;
}

.v-card__text {
  //padding-left: 0px !important;
  //padding-right: 0px !important;
  padding: 0px !important;
}
</style>
